import { z } from "zod";

export enum CardType {
  Any = "Any",
  Vehicle = "Vehicle",
  Driver = "Driver",
  DriverVehicle = "DriverVehicle",
}

export enum Products {
  All = "All",
  AllExcludingAdBlue = "AllExcludingAdBlue",
  AllExcludingTobacco = "AllExcludingTobacco",
  AllExcludingTobaccoAndAdBlue = "AllExcludingTobaccoAndAdBlue",
  DieselOilWashAndService = "DieselOilWashAndService",
  FuelsAndAdBlue = "FuelsAndAdBlue",
  FuelsOilWashService = "FuelsOilWashService",
  FuelsOnly = "FuelsOnly",
  PetrolOilAndWash = "PetrolOilAndWash",
}

export const LimitsModelSchema = z.object({
  daily: z.number().nullable(),
  monthly: z.number().nullable(),
});

export const VehicleModelSchema = z.object({
  registration: z.string().nullable(),
});

export const DriverModelSchema = z.object({
  name: z.string().nullable(),
});
export const CardModelSchema = z.object({
  cardType: z.nativeEnum(CardType).nullable(),
  vehicle: VehicleModelSchema,
  driver: DriverModelSchema,
  products: z.nativeEnum(Products),
  limits: LimitsModelSchema,
  disabled: z.boolean().nullable(),
});
